 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDEDICATION from '@/components/Text/dedication'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTABETTERFREEDOM from '@/components/Text/ABetterFreedom'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXTPARTONE from '@/components/Text/PartOne'
 import TEXTCHAP1 from '@/components/Text/Chap1'
 import TEXTCHAP2 from '@/components/Text/Chap2'
 import TEXTCHAP3 from '@/components/Text/Chap3'
 import TEXTPARTTWO from '@/components/Text/PartTwo'
 import TEXTCHAP4 from '@/components/Text/Chap4'
 import TEXTCHAP5 from '@/components/Text/Chap5'
 import TEXTCHAP6 from '@/components/Text/Chap6'
 import TEXTCHAP7 from '@/components/Text/Chap7'
 import TEXTCHAP8 from '@/components/Text/Chap8'
 import TEXTCHAP9 from '@/components/Text/Chap9'
 import TEXTPARTTHREE from '@/components/Text/PartThree'
 import TEXTCHAP10 from '@/components/Text/Chap10'
 import TEXTCHAP11 from '@/components/Text/Chap11'
 import TEXTCHAP12 from '@/components/Text/Chap12'
 import TEXTCHAP13 from '@/components/Text/Chap13'
 import TEXTCHAP14 from '@/components/Text/Chap14'
 import TEXTCHAP15 from '@/components/Text/Chap15'
 import TEXTCHAP16 from '@/components/Text/Chap16'
 import TEXTEPILOGUE from '@/components/Text/Epilogue'
 import TEXTCODA from '@/components/Text/Coda'
 import TEXTAPPENDIXA from '@/components/Text/AppendixA'
 import TEXTAPPENDIXB from '@/components/Text/AppendixB'
 import TEXTAPPENDIXC from '@/components/Text/AppendixC'
 import TEXTAPPENDIXD from '@/components/Text/AppendixD'
 import TEXTAPPENDIXE from '@/components/Text/AppendixE'
 import TEXTNOTES from '@/components/Text/Notes'
 import TEXTBIBLIOGRAPHY from '@/components/Text/Bibliography'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTMORETITLESFROMIVP from '@/components/Text/MoreTitlesfromIVP'
 import TEXTENDORSEMENT from '@/components/Text/Endorsement'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/ABetterFreedom",
 			"name" : "Text/ABetterFreedom",
 			"component" : TEXTABETTERFREEDOM
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/PartOne",
 			"name" : "Text/PartOne",
 			"component" : TEXTPARTONE
 		},
 		{
 			"path" : "/Text/Chap1",
 			"name" : "Text/Chap1",
 			"component" : TEXTCHAP1
 		},
 		{
 			"path" : "/Text/Chap2",
 			"name" : "Text/Chap2",
 			"component" : TEXTCHAP2
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js